<script>
    import BaseButton from './common/BaseButton.svelte'
    import { sessionExpiredModalShown } from '../store/stores.js'
    import { push } from 'svelte-spa-router'
    import { t } from '../i18n'

    const closeModal = () => {
        push('/')
        window.location.reload()
        sessionExpiredModalShown.set(false)
    }
</script>

<div class="fixed inset-0 bg-black bg-opacity-40 z-40 flex justify-center items-center">
    <div class="bg-white w-96 mx-auto text-center p-8 rounded-md">
        <h2 class="text-navy mb-2">{$t('modal.session-expired-title')}</h2>
        <p class="mb-4">{$t('modal.session-expired-description')}</p>
        <BaseButton buttonType={'secondary'} on:click={closeModal}>{$t('modal.session-expired-button')}</BaseButton>
    </div>
</div>